define('ordersUnpaidTotalsView',[
  'module',
  'marionette',
  'underscore',
  'jquery',
  'app',
  'settings',
  'template!ordersUnpaidTotalsView'
], function (
  Module,
  Marionette,
  _,
  $,
  App,
  Settings,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'unpaid-orders-totals-view',

    initialize: function() {
      this.totals = null;
      this.tableView = this.options.tableView;
    },

    onShow: function() {
      if(this.tableView.filters)
        this.listenTo(this.tableView.filters, 'change:toInvoice', _.bind(this.fetch, this));
      this.fetch();
    },

    onDestroy: function() {
      if(this.fetchRequest)
        this.fetchRequest.abort();
    },

    fetch: function() {
      // Same scope as the table below: unpaid orders in an "order due" status
      var params = {orderDue: 'true'};
      var toInvoice = this.tableView.filters ? this.tableView.filters.get('toInvoice') : '';
      if(toInvoice === 'true' || toInvoice === 'false')
        params.toInvoice = toInvoice;

      if(this.fetchRequest)
        this.fetchRequest.abort();

      this.fetchRequest = $.ajax({
        type: 'GET',
        url: App.request('order:get-unpaid-aging-totals', params),
        success: _.bind(function (totals) {
          this.totals = totals;
          this.render();
        }, this)
      });
    },

    serializeData: function() {
      var numberLocale = Settings.configValue('priceLocale') || 'fr-BE';
      var format = function (value) {
        return '€' + new Intl.NumberFormat(numberLocale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2}).format(value || 0);
      };

      var data = {
        loaded: this.totals !== null,
        tiles: []
      };

      if(this.totals) {
        data.tiles = [
          {className: 'total', label: _.i18n('unpaidOrders.aging.total', null, 'Total'), amount: format(this.totals.amountTotal), count: this.totals.countTotal},
          {className: '', label: _.i18n('unpaidOrders.aging.0to10', null, '0 - 10 days'), amount: format(this.totals.amount0To10), count: this.totals.count0To10},
          {className: '', label: _.i18n('unpaidOrders.aging.10to30', null, '+10 days'), amount: format(this.totals.amount10To30), count: this.totals.count10To30},
          {className: 'warn', label: _.i18n('unpaidOrders.aging.30to60', null, '+30 days'), amount: format(this.totals.amount30To60), count: this.totals.count30To60},
          {className: 'warn', label: _.i18n('unpaidOrders.aging.60to90', null, '+60 days'), amount: format(this.totals.amount60To90), count: this.totals.count60To90},
          {className: 'hot', label: _.i18n('unpaidOrders.aging.90plus', null, '+90 days'), amount: format(this.totals.amount90Plus), count: this.totals.count90Plus}
        ];
      }

      return data;
    }
  });
});

